import { createContext } from 'react';

import { ToastContextType } from './toast.type';

export const DEFAULT_INTERVAL = 5000;

// Success toasts auto-dismiss faster: the message is throw-away confirmation and
// otherwise lingers after the user has already moved on.
export const SUCCESS_INTERVAL = 3000;

/**
 * The context object and its timings only. The provider lives in `toast-provider.tsx`.
 *
 * Split so the hooks layer stops inheriting the provider's render tree: `useToast` needs
 * nothing but this object and `useGenericQuery` uses `useToast`, so the provider's
 * `@components/notification` and `createPortal` came with it (B2B-2142). Do not
 * re-export the provider from here.
 *
 * It also broke a cycle: the provider imports `Notification`, and `notification.tsx`
 * imports `DEFAULT_INTERVAL` from this specifier — which used to resolve to the provider.
 */
export const ToastContext = createContext<ToastContextType>({
  data: [],
  push: () => {},
  remove: () => {},
});
